/*
 * Description  :
 * Date         :2021-11-01 14:02:38
 * LastEditors  :chenjia
 * LastEditTime :2024-07-10 16:02:43
 * FilePath     :\abackup-pay\src\api\api.js
 */
import { ajaxPost } from "../service/httpService";

// 通过soft_id请求商品信息
export const productInfo = (str) => {
  return ajaxPost(`soft-sku/${str}`);
};

//提交订单
export const orders = (obj) => {
  return ajaxPost("orders", obj);
};

//查询订单
export const queryOrders = (order) => {
  return ajaxPost("orders/" + order + "/serial_numbers");
};

//开发票
export const drawBbill = (order, obj) => {
  return ajaxPost("orders/" + order + "/invoices", obj);
};
//发送邮箱
export const sendEamil = (order) => {
  return ajaxPost("/orders/" + order + "/email/resend");
};

//退款
export const sendRefund = (order) => {
  return ajaxPost("/orders/" + order.id + "/refund", { refund_reason: order.refund_reason });
};

// 查询订单列表是否支付
export const isOrdersListPay = (order) => {
  return ajaxPost("orders/query", order);
};
